import { useState } from 'react';
import type { AssessmentQuestion } from '@/lib/types';

interface TrueFalseProps {
  question: AssessmentQuestion;
  onAnswer: (answer: boolean) => void;
  disabled?: boolean;
  currentAnswer?: boolean;
}

export function TrueFalse({
  question,
  onAnswer,
  disabled = false,
  currentAnswer,
}: TrueFalseProps) {
  const [selected, setSelected] = useState<boolean | null>(
    currentAnswer !== undefined ? currentAnswer : null
  );

  const handleSelect = (value: boolean) => {
    if (disabled) return;
    setSelected(value);
    onAnswer(value);
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-slate-900 dark:text-slate-100">
        {question.question}
      </h3>

      <div className="flex gap-4">
        <button
          onClick={() => handleSelect(true)}
          disabled={disabled}
          className={`
            flex-1 px-6 py-4 rounded-lg border-2 transition-all font-medium
            ${
              selected === true
                ? 'border-green-500 bg-green-50 dark:bg-green-900/20 text-green-900 dark:text-green-100'
                : 'border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600'
            }
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
          `}
        >
          ✓ True
        </button>

        <button
          onClick={() => handleSelect(false)}
          disabled={disabled}
          className={`
            flex-1 px-6 py-4 rounded-lg border-2 transition-all font-medium
            ${
              selected === false
                ? 'border-red-500 bg-red-50 dark:bg-red-900/20 text-red-900 dark:text-red-100'
                : 'border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600'
            }
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
          `}
        >
          ✗ False
        </button>
      </div>
    </div>
  );
}
